module.exports = __webpack_public_path__ + "static/1-509939e6adc2551e7a0029bef56eb546.jpg";